<script lang="ts">
  import { onMount, tick } from 'svelte'
  import Navbar from '@/components/appDriver/Navbar.svelte'
  import { currentPage, topupRequest, enquiryResult } from '@/components/appDriver/store'
  import PageHome from '@/components/appDriver/PageHome.svelte'
  import PageTopupChannel from '@/components/appDriver/topup/PageTopupChannel.svelte'
  import { showErrorMessage } from '@/plugins/util'

  const MAX_AMOUNT = 2_000_000

  let amountStr: string = $topupRequest.amount.toString()

  $: $topupRequest.amount = parseInt(amountStr)

  onMount(() => {
    $currentPage = 'topup-amount'
  })

  function getPayableAmount(amount: number) {
    return Math.ceil(amount)
  }

  function onKeyPadPress(key: string) {
    $topupRequest.lastAppointmentBookingId = null

    if (key === 'X') {
      amountStr = amountStr.slice(0, -1)
    } else {
      amountStr += key
    }

    if (amountStr === '') {
      amountStr = '0'
    }

    clampToMax()
  }

  async function setByLastAppointment() {
    if ($enquiryResult && $enquiryResult.user.lastAppointmentBookingId !== null) {
      $topupRequest.lastAppointmentBookingId = $enquiryResult.user.lastAppointmentBookingId
      amountStr = getPayableAmount($enquiryResult.user.lastAppointmentInvoiceTotal).toString()
      clampToMax()
      await tick()
      onNext()
    }
  }

  function clampToMax() {
    const numericAmount = parseInt(amountStr) || 0
    if (numericAmount > MAX_AMOUNT) {
      amountStr = MAX_AMOUNT.toString()
      showErrorMessage('ຈຳນວນສູງສຸດ 2,000,000 LAK')
    } else {
      amountStr = numericAmount.toString()
    }
  }

  function onNext() {
    if ($topupRequest.amount === 0) {
      showErrorMessage('ປ້ອນຈຳນວນເງິນກ່ອນ')
      return
    }
    PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageTopupChannel })
  }
</script>

<div class="page flex flex-col h-full bg-[#EFEFEF]">

  <Navbar showBack={true} on:back={() => PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageHome })}/>

  <img src="{new URL('@/assets/general/loca-logo-horizontal.png', import.meta.url).href}" width="100" class="-mt-10 mx-auto">

  <div class="text-xl text-center font-semibold m-4">ກະລຸນາປ້ອນຈຳນວນເງິນ</div>

  <main class="flex-1 overflow-y-scroll px-4 space-y-4">

    <div class="h-[64px] relative font-semibold flex items-center bg-white rounded-lg shadow-sm overflow-hidden">
      <div class="absolute left-0 top-0 bottom-0 px-3 flex justify-center items-center text-lg bg-white">LAK</div>
      <div class="text-2xl text-center font-semibold tracking-widest appearance-none outline-none w-full px-3">{parseInt(amountStr).toLocaleString()}</div>
    </div>

    <div class="grid grid-cols-3 gap-2">
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('1')}>1</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('2')}>2</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('3')}>3</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('4')}>4</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('5')}>5</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('6')}>6</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('7')}>7</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('8')}>8</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('9')}>9</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('0')}>0</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('00')}>00</div>
      <div class="shadow rounded-lg py-4 text-xl font-bold text-center bg-white" on:click={() => onKeyPadPress('000')}>000</div>

      {#if $enquiryResult && $enquiryResult.user.lastAppointmentBookingId !== null}
        <div class="h-[64px] relative font-semibold flex items-center bg-white rounded-lg shadow overflow-hidden col-span-2" on:click={setByLastAppointment}>
          <div class="absolute left-0 top-0 bottom-0 px-3 flex justify-center items-center text-lg bg-white leading-6">ກົດຕາມຄ່າ<br>ຖ້ຽວລ່າສຸດ</div>
          <div class="text-2xl text-right font-semibold tracking-widest appearance-none outline-none w-full px-3">{getPayableAmount($enquiryResult.user.lastAppointmentInvoiceTotal).toLocaleString()}</div>
        </div>
      {/if}

      <div class="shadow rounded-lg py-4 text-xl font-bold bg-[#E80000] flex items-center justify-center" on:click={() => onKeyPadPress('X')}>
        <svg xmlns="http://www.w3.org/2000/svg" width="28" viewBox="0 0 36 27">
          <g id="Icon_feather-delete" data-name="Icon feather-delete" transform="translate(0 -4.5)">
            <path id="Path_1" data-name="Path 1" d="M31.5,6H12L1.5,18,12,30H31.5a3,3,0,0,0,3-3V9A3,3,0,0,0,31.5,6Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
            <path id="Path_2" data-name="Path 2" d="M27,13.5l-9,9" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
            <path id="Path_3" data-name="Path 3" d="M18,13.5l9,9" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
          </g>
        </svg>
      </div>

    </div>

  </main>

  <div class="h-14 bg-[#1D3549] mt-auto flex justify-center items-center text-white text-xl font-semibold" on:click={onNext}>ຊຳລະເງິນ</div>

</div>
